import { render } from "./ArrivalRecords.vue?vue&type=template&id=00a8aac8&scoped=true"
import script from "./ArrivalRecords.vue?vue&type=script&lang=js"
export * from "./ArrivalRecords.vue?vue&type=script&lang=js"

import "./ArrivalRecords.vue?vue&type=style&index=0&id=00a8aac8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a8aac8"]])

export default __exports__